import React, { Component } from "react";

export default class Header extends Component {
  constructor(props) {
    super(props);
    // dictionary to color the startupcard header based on the type
    this.headerClass = {
      invested_startup: "warning",
      admin: "warning",
      adminBid: "warning",
      new: "warning",
      open: "info",
      sellOpen: "info",
      not_interested: "danger",
      declined: "danger",
      pipeline: "yellow",
      bid_pipeline: "yellow",
      sellPipeline: "yellow",
      committed: "success",
      approved: "success",
      bid: "primary",
      sold: "success"
    };
    this.state = {
      headerColor: this.headerClass[props.type]
    };
    this.renderHeaderPrice = () => {
      switch (this.props.type) {
        case "bid":
        case "adminBid":
          return (
            <span title="Selling share">
              $ {this.props.stakeData.selling_share}
            </span>
          );
        case "committed":
          return (
            <span title="Equity %">{this.props.data.equity_percent} %</span>
          );
        default:
          return (
            <span title="Amount asked">$ {this.props.data.ask_amount}</span>
          );
      }
    };
  }

  render() {
    return (
      <div className={`card-header card-header-${this.state.headerColor}`}>
        <div className="ct-chart" id="completedTasksChart">
          <div className="row">
            <div className="col-lg-8 startup-card-header">
              <span
                className="badge badge-pill badge-primary"
                title={this.props.data.client_segment.display_name}
              >
                {this.props.data.client_segment.name}
              </span>
              <span
                className="badge badge-pill badge-primary"
                title={this.props.data.stage.display_name}
              >
                {this.props.data.stage.name}
              </span>
            </div>
            <div className="col-lg-4 text-right">
              {this.renderHeaderPrice()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
